// Function to create a storage key specific to a module/page
const createFilterStorageKey = (moduleIdentifier = "documents") => {
  return `filters-${moduleIdentifier}`;
};

// Default key for backward compatibility
const FILTER_STORAGE_KEY = "document-search-filters";

export const saveFiltersToSession = (filters, moduleIdentifier) => {
  try {
    const key = moduleIdentifier
      ? createFilterStorageKey(moduleIdentifier)
      : FILTER_STORAGE_KEY;

    sessionStorage.setItem(key, JSON.stringify(filters));
    return true;
  } catch (error) {
    return false;
  }
};

export const getFiltersFromSession = (moduleIdentifier) => {
  try {
    const key = moduleIdentifier
      ? createFilterStorageKey(moduleIdentifier)
      : FILTER_STORAGE_KEY;

    const storedFilters = sessionStorage.getItem(key);
    return storedFilters ? JSON.parse(storedFilters) : null;
  } catch (error) {
    return null;
  }
};

export const clearFiltersFromSession = (moduleIdentifier) => {
  try {
    const key = moduleIdentifier
      ? createFilterStorageKey(moduleIdentifier)
      : FILTER_STORAGE_KEY;

    sessionStorage.removeItem(key);
    return true;
  } catch (error) {
    return false;
  }
};

// New function to clear all filters from all pages
export const clearAllFiltersFromSession = () => {
  try {
    // Get all keys from sessionStorage
    const allKeys = Object.keys(sessionStorage);

    // Filter keys that are filter-related (either have our prefix or the legacy key)
    const filterKeys = allKeys.filter(
      (key) => key.startsWith("filters-") || key === FILTER_STORAGE_KEY
    );

    // Remove each filter key
    filterKeys.forEach((key) => {
      sessionStorage.removeItem(key);
    });

    return true;
  } catch (error) {
    return false;
  }
};
